import { getDB } from "src/db/databases"
import { useCacheStore } from "src/stores/cacheStore"
import { Log } from "src/util/classes/log"
import { getWorkOrderPriority } from "src/util/http/csi/workOrderPriorities"
import { WorkOrderPriority } from "src/util/types/dataModels/workOrderPriority"
import { PriorityClass } from "src/util/types/misc"
import { numberToPriorityClass } from "./misc"

/**
 * Maps `workOrderPriority` to the css classname of the associated color.
 */
export function getWorkOrderPriorityColor(workOrderPriority: WorkOrderPriority): PriorityClass {
  return numberToPriorityClass(workOrderPriority.rank)
}

export async function getWorkOrderPriorityData(
  workOrderPriorityId: string
): Promise<WorkOrderPriority | undefined> {
  try {
    const cacheStore = useCacheStore()

    const priorityInCache = cacheStore.work_order_priority.get(workOrderPriorityId)

    if (priorityInCache) {
      return priorityInCache
    } else {
      const db = await getDB()
      const workOrderPriorityInDb = await db.work_order_priority.findOne(workOrderPriorityId).exec()

      if (workOrderPriorityInDb) {
        const priorityMutable = workOrderPriorityInDb.toMutableJSON()
        cacheStore.work_order_priority.set(priorityMutable.id, priorityMutable)
        return priorityMutable
      } else {
        return await getWorkOrderPriority({}, workOrderPriorityId)
      }
    }
  } catch (error) {
    Log.error({
      message: "An error occurred while fetching Work Order Priority data",
      error,
    })
  }
}

export async function getHighestWorkOrderPriority(
  workOrderPriorityIds: string[]
): Promise<WorkOrderPriority | undefined> {
  try {
    const db = await getDB()
    const highestPriority = await db.work_order_priority
      .findOne()
      .where({ id: { $in: workOrderPriorityIds } })
      .sort({ rank: "desc" })
      .exec()
    return highestPriority?.toJSON()
  } catch (error) {
    Log.error({
      message: "Could not get highest Work Order Priority data",
      error,
      data: { workOrderPriorityIds },
    })
  }
}
